import { ConfiguratorId, ConfiguratorOptionGroup, OptionId } from "#models/Configurator"
import { makeQueryKey } from "effect-app/client"
import * as Struct from "effect/Struct"
import { S, TaggedRequestFor } from "../../lib.ts"
import { AllConfiguratorOptions } from "./Option.ts"

// codegen:start {preset: meta, sourcePrefix: src/resources/ }
const Req = TaggedRequestFor("Admin/Configurator/OptionGroup")
// codegen:end

export const CloneConfiguratorOptionGroupInput = ConfiguratorOptionGroup.mapFields(Struct.omit(["timestamps", "id"]))

export class CloneConfiguratorOptionGroup extends Req.Command<
  CloneConfiguratorOptionGroup
>()(
  "CloneConfiguratorOptionGroup",
  {
    targetId: ConfiguratorId,
    sourceId: ConfiguratorId,
    optionGroupIds: S.Array(S.StringId), // unique ids of the option group in the source configurator
    options: S.Array(S.Struct({ optionId: OptionId, optionGroupId: S.StringId }))
  },
  {},
  (queryKey) => [
    { filters: { queryKey } },
    { filters: { queryKey: makeQueryKey(AllConfiguratorOptions) } }
  ]
) {}

export class ConfiguratorOptionGroupInput
  extends S.Opaque<ConfiguratorOptionGroupInput, ConfiguratorOptionGroupInput.Encoded>()(
    S
      .Struct(Struct.omit(ConfiguratorOptionGroup.fields, ["timestamps", "id", "options"]))
      .annotate({ identifier: "ConfiguratorOptionGroupInput" })
  )
{}

export class CreateConfiguratorOptionGroup
  extends Req.Command<CreateConfiguratorOptionGroup>()("CreateConfiguratorOptionGroup", {
    configuratorId: ConfiguratorId,
    optionGroup: ConfiguratorOptionGroupInput
  }, {
    success: S.Struct({
      id: S.StringId
    })
  }, (queryKey) => [
    { filters: { queryKey } },
    { filters: { queryKey: makeQueryKey(AllConfiguratorOptions) } }
  ])
{}

export class GetConfiguratorOptionGroup extends Req.Query<GetConfiguratorOptionGroup>()("GetConfiguratorOptionGroup", {
  id: S.StringId,
  configuratorId: ConfiguratorId
}, { success: ConfiguratorOptionGroup }) {}

export class RemoveConfiguratorOptionGroup extends Req.Command<RemoveConfiguratorOptionGroup>()(
  "RemoveConfiguratorOptionGroup",
  {
    configuratorId: ConfiguratorId,
    id: S.StringId
  },
  {},
  (queryKey) => [
    { filters: { queryKey } },
    { filters: { queryKey: makeQueryKey(AllConfiguratorOptions) } }
  ]
) {}

export class SortConfiguratorOptionGroup extends Req.Command<SortConfiguratorOptionGroup>()(
  "SortConfiguratorOptionGroup",
  {
    configuratorId: ConfiguratorId,
    order: S.Array(S.StringId)
  },
  {},
  (queryKey) => [
    { filters: { queryKey } },
    { filters: { queryKey: makeQueryKey(AllConfiguratorOptions) } }
  ]
) {}

export class UpdateConfiguratorOptionGroup extends Req.Command<UpdateConfiguratorOptionGroup>()(
  "UpdateConfiguratorOptionGroup",
  {
    configuratorId: ConfiguratorId,
    id: S.StringId,
    optionGroup: ConfiguratorOptionGroupInput
  },
  {},
  (queryKey) => [
    { filters: { queryKey } },
    { filters: { queryKey: makeQueryKey(AllConfiguratorOptions) } }
  ]
) {}

// codegen:start {preset: model}
//
export namespace ConfiguratorOptionGroupInput {
  export interface Encoded extends S.StructNestedEncoded<typeof ConfiguratorOptionGroupInput> {}
}
//
// codegen:end
